import React from 'react';
import PropTypes from 'prop-types';
import BasicButton from 'components/BasicButton';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './styles.css';

const DialogQuestLayout = (props) => {
  const {
    message,
    cases,
    titleLeft,
    titleRight,
  } = props;
  return (
    <div className="dialog-quest-layout">
      {message && (
        <div className="dialog-quest-layout--message">
          {message}
        </div>
      )}
      {titleRight && titleLeft && (
        <div className="dialog-quest-layout--row">
          <div className="dialog-quest-layout--column-left">
            <span className="dialog-quest-layout--column-title">{titleLeft}</span>
          </div>
          <div className="dialog-quest-layout--column-right">
            <span className="dialog-quest-layout--column-title">{titleRight}</span>
          </div>
        </div>
      )}
      {cases.map((item, index) => (
        <div key={index} className="dialog-quest-layout--row">
          <div className="dialog-quest-layout--column-left">
            <div className="dialog-quest-layout--situation-desc">
              <span>
                {item.title}
              </span>
              <FontAwesomeIcon
                icon={faChevronRight}
                size="lg"
                className="dialog-quest-layout--chevron"
              />
            </div>
          </div>
          <div className="dialog-quest-layout--column-right">
            <BasicButton
              controlFunc={item.action}
              btnFontWeight={500}
              btnArrow={false}
              btnTextColor="#27282d"
              btnTextAlign="center"
              btnText={item.buttonText}
            />
            {item.helpText && (
              <span className="dialog-quest-layout--help-text">
                {item.helpText}
                </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

DialogQuestLayout.propTypes = {
  message: PropTypes.string,
  cases: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      buttonText: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired,
      helpText: PropTypes.string,
    }),
  ).isRequired,
  titleLeft: PropTypes.string,
  titleRight: PropTypes.string,
};

export default DialogQuestLayout;
